















































































import Vue from "vue";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { NewsManagerService } from "@/common/api";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import QSelect2 from "@/common/qSelect2.vue";
import { CATEGORIES } from "@/model/article";
import linkifyHtml from "linkify-html";

@Component({
  name: "UserAdd",
  components: {
    QSelect2,
    QErrors,
  },
})
export default class UserAdd extends Vue {
  public isShow = false;
  public isEdit = false;
  public errors = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public news: any = {};

  public categories = CATEGORIES;

  public initForm = {
    category: "お知らせ",
    title: "",
    context: "",
  };

  public form: any = {};

  public option = [];
  public select2Config = { width: "100%" };

  public clearForm() {
    this.$el.querySelector(".context").textContent = "";
    this.initForm = {
      category: "お知らせ",
      title: "",
      context: "",
    };
    this.form = { ...this.initForm };
    this.errors = {};
    this.news = {};
    this.isEdit = false;
  }

  public preventChange = false;

  public preventChangeText(event) {
    const keyCode = [13, 91, 37, 38, 39, 40];
    this.preventChange =
      keyCode.includes(event.keyCode) ||
      ((event.metaKey || event.ctrlKey) && event.keyCode != 86);
  }

  public convertToLink() {
    let text = "";
    const contextElement = this.$el.querySelector(".context");
    if (contextElement) {
      text = contextElement.innerHTML
        .replace(/<[^>]*a>/g, "")
        .replace(/<a[^>]*>/g, "");
    }

    this.$el.querySelector(".context").innerHTML = linkifyHtml(text, {
      target: "_blank",
    });
  }

  public changeText(event) {
    const element = document.querySelector("#context");
    const position = this.getCaretCharacterOffsetWithin(element);
    if (this.preventChange) return;
    const keyCode = [8];

    let text = "";
    const contextElement = this.$el.querySelector(".context");
    if (contextElement) {
      text = contextElement.innerHTML
        .replace(/<[^>]*a>/g, "")
        .replace(/<a[^>]*>/g, "");
    }

    if (keyCode.includes(event.keyCode) && text.includes("<div><br></div>")) {
      return;
    }

    this.$el.querySelector(".context").innerHTML = linkifyHtml(text, {
      target: "_blank",
    });

    this.setCurrentCursorPosition(element, position);
  }

  public createRange(node, chars, range = null) {
    if (!range) {
      range = document.createRange();
      range.selectNode(node);
      range.setStart(node, 0);
    }

    if (chars.count === 0) {
      range.setEnd(node, chars.count);
    } else if (node && chars.count > 0) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.length < chars.count) {
          chars.count -= node.textContent.length;
        } else {
          range.setEnd(node, chars.count);
          chars.count = 0;
        }
      } else {
        for (var lp = 0; lp < node.childNodes.length; lp++) {
          range = this.createRange(node.childNodes[lp], chars, range);

          if (chars.count === 0) {
            break;
          }
        }
      }
    }

    return range;
  }

  public setCurrentCursorPosition(element, chars) {
    if (chars > 0) {
      var selection = window.getSelection();

      const range = this.createRange(element.parentNode, { count: chars });

      if (range) {
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }

  public getCaretCharacterOffsetWithin(element) {
    var caretOffset = 0;
    var documentElement = element.ownerDocument || element.document;
    var win = documentElement.defaultView || documentElement.parentWindow;
    var sel;
    if (typeof win.getSelection != "undefined") {
      sel = win.getSelection();
      if (sel.rangeCount > 0) {
        var range = win.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        caretOffset = preCaretRange.toString().length;
      }
    } else if ((sel = documentElement.selection) && sel.type != "Control") {
      var textRange = sel.createRange();
      var preCaretTextRange = documentElement.body.createTextRange();
      preCaretTextRange.moveToElementText(element);
      preCaretTextRange.setEndPoint("EndToEnd", textRange);
      caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
  }

  public show(news = null) {
    this.clearForm();

    if (news) {
      this.isEdit = true;
      this.news = news;
      this.form = {
        category: news.category,
        title: news.title,
        context: news.context,
      };
      this.initForm = { ...this.form };
      this.$el.querySelector(".context").innerHTML = news.context;
    }

    this.isShow = true;
  }

  async addNews() {
    this.errors = {};
    let result;
    try {
      const context = this.$el.querySelector(".context").innerHTML;
      const textContent = this.$el.querySelector(".context").textContent;
      result = await NewsManagerService.newsCreate({
        ...this.form,
        ...{
          context: context,
          plainContext: textContent,
        },
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("closeAdded");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  async editNews() {
    this.errors = {};
    let result;
    try {
      const context = this.$el.querySelector(".context").innerHTML;
      const textContent = this.$el.querySelector(".context").textContent;
      result = await NewsManagerService.newsEdit({
        ...this.form,
        ...{
          context: context,
          plainContext: textContent,
        },
        ...{ id: this.news.id },
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.$emit("closeEdited", result.data.news);
      this.isShow = false;
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public confirmDeleteNews() {
    this.errors = {};
    this.$modal.showDelete({
      text: this.$t("common.modal.delete_content"),
      onConfirm: () => {
        this.deleteNews();
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  async deleteNews() {
    let result;
    try {
      result = await NewsManagerService.newsDelete({
        id: this.news.id,
      });
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.deleted"),
      });
      this.isShow = false;
      this.$emit("closeDeleted");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }
  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    const form = {
      ...this.form,
      ...{ context: this.$el.querySelector(".context").innerHTML },
    };
    return !compareWithKeys(form, this.initForm, [
      "category",
      "title",
      "context",
    ]);
  }
}
